import React from "react";
import ReactDOM from "react-dom/client";

import "./index.css";
import "@introist/react-foundation/v2/index.css";
import "@introist/react-foundation/lib/index.css";
import "@introist/react-foundation/lib/DateInput.css";

import App from "./App";
import { ActionProvider } from "@introist/react-foundation/v2";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ActionProvider defaultErrorMessage="Something went wrong">
      <App />
    </ActionProvider>
  </React.StrictMode>
);
